import type { HTMLAttributes, ReactNode } from 'react';

/** Shared admin chrome; page workflows and narrow form bodies remain children. */
export function AdminPage({
  className = '',
  contentClassName,
  header,
  children,
  ...props
}: HTMLAttributes<HTMLDivElement> & { contentClassName?: string; header?: ReactNode }) {
  return (
    <div className={`admin-page ${className}`} {...props}>
      {header}
      {contentClassName ? <div className={contentClassName}>{children}</div> : children}
    </div>
  );
}

export function AdminPageHeader({
  title,
  titleAside,
  description,
  back,
  actions,
  className = '',
}: {
  title: ReactNode;
  titleAside?: ReactNode;
  description?: ReactNode;
  back?: ReactNode;
  actions?: ReactNode;
  className?: string;
}) {
  return (
    <header className={`admin-page-header ${className}`}>
      {back && <div className="admin-page-back">{back}</div>}
      <div className="admin-page-heading">
        <div className="min-w-0">
          {titleAside ? (
            <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
              <h1 className="admin-page-title min-w-0">{title}</h1>
              {titleAside}
            </div>
          ) : (
            <h1 className="admin-page-title">{title}</h1>
          )}
          {description && <div className="admin-page-description">{description}</div>}
        </div>
        {actions && <div className="admin-page-actions">{actions}</div>}
      </div>
    </header>
  );
}
